import { getComputedStylePropertyValue } from "./getComputedStylePropertyValue"

export const colors = {
  topaz: "var(--color-topaz)",
  turquoise: "var(--color-turquoise)",
  emerald: "var(--color-emerald)",
  ruby: "var(--color-ruby)",
  marigold: "var(--color-marigold)",
  tint0: "var(--color-tint0)",
  tint1: "var(--color-tint1)",
  tint2: "var(--color-tint2)",
  tint3: "var(--color-tint3)",
  tint4: "var(--color-tint4)",
  tint5: "var(--color-tint5)",
  tint6: "var(--color-tint6)",
  tint7: "var(--color-tint7)",
  tint8: "var(--color-tint8)",
  tint9: "var(--color-tint9)",
  tint10: "var(--color-tint10)",
  brand: "var(--color-brand)",
  brandGradientStart: "var(--color-brand-gradient-start)",
  brandGradientEnd: "var(--color-brand-gradient-end)",
}

export function getComputedColorValues() {
  return {
    topaz: getComputedStylePropertyValue("--color-topaz"),
    turquoise: getComputedStylePropertyValue("--color-turquoise"),
    emerald: getComputedStylePropertyValue("--color-emerald"),
    ruby: getComputedStylePropertyValue("--color-ruby"),
    marigold: getComputedStylePropertyValue("--color-marigold"),
    tint0: getComputedStylePropertyValue("--color-tint0"),
    tint1: getComputedStylePropertyValue("--color-tint1"),
    tint2: getComputedStylePropertyValue("--color-tint2"),
    tint3: getComputedStylePropertyValue("--color-tint3"),
    tint4: getComputedStylePropertyValue("--color-tint4"),
    tint5: getComputedStylePropertyValue("--color-tint5"),
    tint6: getComputedStylePropertyValue("--color-tint6"),
    tint7: getComputedStylePropertyValue("--color-tint7"),
    tint8: getComputedStylePropertyValue("--color-tint8"),
    tint9: getComputedStylePropertyValue("--color-tint9"),
    tint10: getComputedStylePropertyValue("--color-tint10"),
    brand: getComputedStylePropertyValue("--color-brand"),
    brandGradientStart: getComputedStylePropertyValue(
      "--color-brand-gradient-start",
    ),
    brandGradientEnd: getComputedStylePropertyValue(
      "--color-brand-gradient-end",
    ),
  }
}
